export const validateStep6 = () => () => {
    return false;
}



// WEBPACK FOOTER //
// ./src/components/CreateSite/Step6/Validator.js